export const renameLabelCopy = {
  header: '',
  description: '',
  inputLabel: '',
  confirmBtnText: '',
  successToast: '',
};
